/***
 * @file: è¡¨æ ¼æä½åºç¡æå¡ç±»ï¼ æ°å¢ add, ä¿®æ¹ editï¼ æ¥ç view
 * @author: linkun.he
 * @Date: 2019-06-11 11:13:09
 */
import { EventEmitter, Injector, Output } from '@angular/core';
import { FormBuilder, FormControl, FormGroup } from '@angular/forms';
import { trim } from 'lodash';

import { SettingsService, TenantService } from '@ithinkdt/shared/browser';
import { I18NService } from '@ithinkdt/shared/i18n';
import { DtMessageService } from '@ithinkdt/shared/message';
import { isExist, standardDate } from '@ithinkdt/shared/utils';

export abstract class BaseTableOprPage {
  // code: æ è¯å½åæ¯åªä¸ªæä½, data: è¡¨åçæ°æ®
  code: string;
  data: any;
  // å·æ°è¡¨æ ¼
  @Output() refreshTable = new EventEmitter();
  // è¡¨åå¯¹è±¡ï¼æ è¯äºæåªäºè¡¨åæ§ä»¶
  form: FormGroup;
  // å¼¹çªæ é¢
  title: string;
  // ç¡®è®¤æé®æå­
  sureBtn: string;
  // æ¯å¦æ¾ç¤ºæ¨¡ææ¡
  visible = false;
  // æ¯å¦æäº¤ç¶æ
  isSubmiting = false;
  // æä½codeç 
  oprCodes: any;
  dateKeysArr: string[] = [];

  saveFunc: any;
  addSaveFunc: any;
  editSaveFunc: any;

  get multiTenantMode(): boolean {
    return this.TenantSrv.multiTenantMode;
  }

  // æ¯å¦ä¸ºå¤ç§æ·æ¨¡å¼ä¸æ¯å¹³å°ç®¡çå
  get isPlatformAdmin(): boolean {
    return this.TenantSrv.isPlatformAdmin;
  }

  protected fb: FormBuilder; // å½éå
  protected messageSrv: DtMessageService; // è¡¨åæå¡
  protected settingsSrv: SettingsService; // ç¨æ·è®¾ç½®æå¡
  protected i18NSrv: I18NService; // æéæå¡
  protected TenantSrv: TenantService; // ç§æ·æå¡

  constructor(public inj: Injector) {
    this.fb = this.inj.get(FormBuilder);
    this.messageSrv = this.inj.get(DtMessageService);
    this.settingsSrv = this.inj.get(SettingsService);
    this.i18NSrv = this.inj.get(I18NService);
    this.TenantSrv = this.inj.get(TenantService);

    this.oprCodes = this.settingsSrv.userConfig.env.oprCodes || {};

    this.initBaseForm();
  }

  initBaseForm() {
    if (this.initBaseFormReserved() === false) {
      return;
    }

    this.form = this.fb.group(this.baseForm);
  }

  // æ°å¢
  add(data?) {
    this.code = this.oprCodes.add;
    if (this.addReserved(data) === false) {
      return;
    }

    const addForm = { ...this.baseForm, ...this.addFormOnly };
    this.addControls(addForm);

    this.setTitleAndBtn('operations.add.add', 'operations.save');
    this.open();
  }

  // ç¼è¾
  edit(data?) {
    this.code = this.oprCodes.edit;
    this.data = data;
    if (this.editReserved(data) === false) {
      return;
    }

    const editForm = { ...this.baseForm, ...this.editFormOnly };
    this.addControls(editForm);

    this.setFormData(data);
    this.setTitleAndBtn('operations.edit.edit', 'operations.save');
    this.open();
  }

  view(data?) {
    this.code = this.oprCodes.view;
    this.data = data;
    if (this.editReserved(data) === false) {
      return;
    }

    const viewForm = { ...this.baseForm, ...this.viewFormOnly };
    this.addControls(viewForm);

    this.setFormData(data);
    this.form.disable();
    this.setTitleAndBtn('operations.view');
    this.open();
  }

  setFormData(data) {
    for (const key in this.form.controls) {
      if (isExist(this.dateKeysArr, key) && data[key]) {
        data[key] = standardDate(data[key]);
      }
      this.form.get(key).setValue(data[key]);
    }
  }

  /**
   * è®¾ç½®æ é¢åæé®åå®¹
   * @param title è®¾ç½®çæ é¢
   * @param btnName è®¾ç½®çæé®åç§°
   */
  setTitleAndBtn(title?: string, btnName?: string) {
    this.title = this.i18NSrv.interpret(title);
    this.sureBtn = this.i18NSrv.interpret(btnName);
  }

  // æå¼æ¨¡ææ¡
  open() {
    if (this.openReserved() === false) {
      return;
    }
    this.visible = true;
  }

  // å³é­æ¨¡ææ¡
  close() {
    if (this.closeReserved() === false) {
      return;
    }
    this.visible = false;
    if (this.form) {
      switch (this.code) {
        case this.oprCodes.add:
          this.removeControls(this.addFormOnly);
          break;
        case this.oprCodes.edit:
          this.removeControls(this.editFormOnly);
          break;
        case this.oprCodes.view:
          this.removeControls(this.viewFormOnly);
          break;
      }

      this.form.enable();
      this.form.reset();
    }
    this.code = null;
  }

  /**
   * @desc å¨ææ·»å è¡¨åæ§ä»¶
   * @param ctrls è¦æ·»å çformæ§ä»¶çéç½®é¡¹
   */
  addControls(ctrls) {
    const keys = Object.keys(ctrls); // ååºææéè¦éç½®çkeyï¼å®æ¯ä¸ä¸ªæ°ç»
    // å¾ªç¯æ·»å æ§ä»¶
    keys.forEach((key) => {
      this.form.addControl(
        key,
        new FormControl(...ctrls[key]) // form[key]æ¯ä¸ä¸ªæ°ç»ï¼æä»¥éè¦å±å¼ï¼ä¸ç¶åªä¼è¢«è®¤ä¸ºæ¯ä¸ä¸ªvalueå¼èæ²¡æäºéªè¯è§å
      );
    });
  }

  // ç§»é¤è¡¨åæ§ä»¶,æ·»å äºåªäºå°±ç§»é¤åªäº
  removeControls(ctrls) {
    const keys = Object.keys(ctrls); // ååºææéè¦éç½®çkeyï¼å®æ¯ä¸ä¸ªæ°ç»
    keys.forEach((key) => {
      this.form.removeControl(String(key));
    });
  }

  get baseForm(): object {
    return {};
  }

  get addFormOnly(): object {
    return {};
  }

  get editFormOnly(): object {
    return {};
  }

  get viewFormOnly(): object {
    return {};
  }

  // æäº¤æ°æ®
  submit() {
    for (const i in this.form.controls) {
      let val = this.form.controls[i].value;
      if (typeof val === 'string') {
        val = trim(val);
      }
      this.form.controls[i].setValue(val);

      this.form.controls[i].markAsDirty();
      this.form.controls[i].updateValueAndValidity();
    }
    if (this.form.valid) {
      switch (this.code) {
        case this.oprCodes.add:
          this.saveFunc = this.addSaveFunc;
          if (this.addSaveReserved() === false) {
            return;
          }

          this.addOrEditSave();
          break;
        case this.oprCodes.edit:
          this.saveFunc = this.editSaveFunc;
          if (this.editSaveReserved() === false) {
            return;
          }
          this.addOrEditSave();
          break;
        default:
          break;
      }
    }
  }

  // å¢å æèç¼è¾è§è²æ¨¡ææ¡ç¡®å®
  addOrEditSave() {
    this.isSubmiting = true;
    this.saveFunc(this.form.getRawValue()).subscribe((res) => {
      if (res.status) {
        this.handlerSucc(this.code === this.oprCodes.add ? 'operations.add.succ' : 'operations.edit.succ');
        this.close();
      }
      this.isSubmiting = false;
    });
  }

  /**
   * ä¿å­æå
   * @param title æåæ¶æ¯
   */
  handlerSucc(title: string) {
    this.messageSrv.success(title);
    this.refreshTable.emit();
  }

  /********************************************************************************
   *
   *  ä»¥ä¸æ¹æ³ä¸ºé¢çæ¹æ³ï¼è¥base-table-opræä¾çæ¹æ³ä¸è¶³ä»¥æ»¡è¶³éæ±ï¼å¯å¨å­ç±»ä¸­è¦çå¦ä¸æ¹æ³ã
   *  å¨è¦ççæ¹æ³ä¸­ï¼è¿åtrueåå¶ä»æ¹æ³ä¹ä¼æ§è¡ï¼è¿åfalseååªä¼æ§è¡è¦ççæ¹æ³ã
   *
   *  å¦ï¼
   *     å¨å­ç±»åªè½ä¸­å®ç°äº`addReserved`æ¹æ³å¹¶è¿åäºfalseï¼å`add()`
   *     æ¹æ³éé¢çå¶ä»jsä¸ä¼æ§è¡ï¼åªææ§è¡å®ä¹ç`addReserved`æ¹æ³ã
   *
   ********************************************************************************/

  // æ¨¡ææ¡æå¼
  openReserved(): boolean {
    return true;
  }

  // æ¨¡ææ¡å³é­
  closeReserved(): boolean {
    return true;
  }

  // åå§åformè¡¨å
  initBaseFormReserved(): boolean {
    return true;
  }

  // æ°å¢
  addReserved(data?): boolean {
    return true;
  }

  // ä¿®æ¹
  editReserved(data?): boolean {
    return true;
  }

  // æ¥ç
  viewReserved(data?): boolean {
    return true;
  }

  // æ°å¢æ¶æ°æ®æäº¤
  addSaveReserved(): boolean {
    return true;
  }

  // ä¿®æ¹æ¶æ°æ®æäº¤
  editSaveReserved(): boolean {
    return true;
  }
}
